export const RUN_STATUS_MAP = [
  { id: 'pending', name: 'In Progress' },
  { id: 'failed', name: 'Failed' },
  { id: 'completed', name: 'Completed' },
  { id: 'none', name: 'None' },
  { id: 'cancelled', name: 'Cancelled' },
  { id: 'waiting', name: 'Waiting' },
];
